import React from 'react';
import PropTypes from 'prop-types';
import { Marker, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import { getIconByMapLayer } from '../../utils/getPropertyIcon';

import './BusinessMapMarker.css';

const BusinessMapMarker = ({ business, markers }) => (
  <Marker
    icon={Leaflet.icon({ iconUrl: getIconByMapLayer('Business', 'share/marker-business.png', markers) })}
    position={[
      parseFloat(business.latitude),
      parseFloat(business.longitude),
    ]}
  >
    <Popup className="leaflet-business-popup">
      <div className="business-popup">
        <b>{business.name}</b>
        <p>NAICS: {business.naicsCode}</p>
        <p>SIC: {business.sicCode}</p>
        <p>{business.numEmployees} Employees</p>
      </div>
    </Popup>
  </Marker>
);

BusinessMapMarker.propTypes = {
  business: PropTypes.object,
  markers: PropTypes.object,
};

export default BusinessMapMarker;



// WEBPACK FOOTER //
// ./src/components/Map/BusinessMapMarker.js